import React, { useState } from 'react'
import {
  Box,
  ButtonBase,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
  Grid,
} from '@material-ui/core'

import useSnackbar from 'hooks/useSnackbar'

import {
  Trash as TrashIcon,
  Award as AwardIcon,
  Check as CheckIcon,
} from 'react-feather'

import * as service from 'service'

import theme from 'theme'
import helpers from 'helpers'

const CardComponent = ({ value, refresh }) => {
  const snackbar = useSnackbar()
  const [showOptions, setShowOptions] = useState(false)
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const setBackgroundColor = (value) => {
    switch (value?.status) {
      case 'PRIMARY':
        return '#FFF'
      case 'ACTIVE':
        return '#FFF'
      default:
        return '#e8ecec'
    }
  }

  const ButtonComponent = ({
    icon,
    background,
    iconColor,
    title,
    subtitle,
    value,
    refresh,
    ...rest
  }) => {
    return (
      <Button
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          width: '100%',
          backgroundColor: '#FFF',
          padding: '20px',
          borderRadius: '20px',
          border: '1px solid #EDEDED',
          marginBottom: '20px',
        }}
        {...rest}
      >
        <Grid container>
          <Grid item xs={12} sm={2} md={2} lg={2}>
            <Box
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                height: '100%',
              }}
            >
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: background,
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                }}
              >
                {icon === 'award' && <AwardIcon size={16} color={iconColor} />}
                {icon === 'trash' && <TrashIcon size={16} color={iconColor} />}
                {icon === 'check' && <CheckIcon size={16} color={iconColor} />}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={10} md={10} lg={10}>
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'start',
              }}
            >
              <Typography
                variant="body1"
                color="textPrimary"
                style={{ fontWeight: 'bold', textTransform: 'capitalize' }}
              >
                {title}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                style={{ textAlign: 'left', textTransform: 'capitalize' }}
              >
                {subtitle}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Button>
    )
  }

  const Label = ({ value }) => {
    switch (value?.status) {
      case 'PRIMARY':
        return (
          <Tooltip title="Essa conta está ativa e definida como principal. Portanto, todos os saques serão direcionados para ela.">
            <Box
              style={{
                backgroundColor: theme.palette.primary.main,
                padding: '2px 8px 2px 8px',
                borderRadius: '4px',
                marginBottom: '20px',
              }}
            >
              <Typography variant="body2" style={{ color: '#FFF' }}>
                Principal
              </Typography>
            </Box>
          </Tooltip>
        )
      case 'ACTIVE':
        return (
          <Tooltip title="Esta conta está ativa, e você pode defini-la como principal a qualquer momento.">
            <Box
              style={{
                backgroundColor: theme.palette.secondary.main,
                padding: '2px 8px 2px 8px',
                borderRadius: '4px',
                marginBottom: '20px',
              }}
            >
              <Typography variant="body2" style={{ color: '#FFF' }}>
                Ativa
              </Typography>
            </Box>
          </Tooltip>
        )
      case 'INACTIVE':
        return (
          <Tooltip title="A Equipe Superfin analisará as informações fornecidas e, se aprovadas, liberará o registro.">
            <Box
              style={{
                backgroundColor: 'silver',
                padding: '2px 8px 2px 8px',
                borderRadius: '4px',
                marginBottom: '20px',
              }}
            >
              <Typography variant="body2" style={{ color: '#FFF' }}>
                Inativa
              </Typography>
            </Box>
          </Tooltip>
        )
      case 'WAITING_CONFIRMATION':
        return (
          <Tooltip title="A Equipe Superfin analisará as informações fornecidas e, se aprovadas, liberará o registro.">
            <Box
              style={{
                backgroundColor: theme.palette.black,
                padding: '2px 8px 2px 8px',
                borderRadius: '4px',
                marginBottom: '20px',
              }}
            >
              <Typography variant="body2" style={{ color: '#FFF' }}>
                Aguardando Confirmação
              </Typography>
            </Box>
          </Tooltip>
        )
      default:
        return ''
    }
  }
  const ModalStatus = ({ value }) => {
    switch (value?.status) {
      case 'PRIMARY':
        return (
          <DialogContent>
            <DialogContentText>
              Essa conta está ativa e definida como principal. Portanto, todos
              os saques serão direcionados para ela.
            </DialogContentText>
            <ButtonComponent
              icon="trash"
              background="#EEBDC1"
              iconColor="#B71C1C"
              title="Desativar"
              subtitle="Desative a conta para impedir seu uso."
              value={value}
              onClick={() => disableBank(value?.id)}
            />
          </DialogContent>
        )
      case 'INACTIVE':
        return (
          <DialogContent>
            <DialogContentText>
              Esta conta está inativa. Ative-a para poder utilizá-la.
            </DialogContentText>
            <ButtonComponent
              icon="check"
              background="#9FF89F"
              iconColor="#00A900"
              title="Tornar a conta ativa"
              subtitle="Ative esta conta bancária para poder utilizá-la."
              value={value}
              onClick={() => enableBank(value?.id)}
            />
          </DialogContent>
        )
      case 'ACTIVE':
        return (
          <DialogContent>
            <DialogContentText>
              Esta conta está ativa, e você pode defini-la como principal a
              qualquer momento.
            </DialogContentText>
            <ButtonComponent
              icon="award"
              background="#e2f4f9"
              iconColor="#1885A3"
              title="Tornar como principal"
              subtitle="A conta bancária principal receberá os depósitos da Superfin, desde que esteja ativada."
              value={value}
              onClick={() => primaryBank(value?.id)}
            />
            <ButtonComponent
              icon="trash"
              background="#EEBDC1"
              iconColor="#B71C1C"
              title="Desativar"
              subtitle="A conta desativada não poderá ser utilizada enquanto permanecer inativa."
              value={value}
              onClick={() => disableBank(value?.id)}
            />
          </DialogContent>
        )
      case 'WAITING_CONFIRMATION':
        return (
          <DialogContent>
            <DialogContentText>
              A Equipe Superfin analisará as informações fornecidas e, se
              aprovadas, liberará o registro.
            </DialogContentText>
          </DialogContent>
        )
      default:
        return ''
    }
  }

  const handleMouseEnter = () => {
    setShowOptions(true)
  }

  const handleMouseLeave = () => {
    setShowOptions(false)
  }

  const disableBank = async (id) => {
    //desativar banco
    try {
      await service.intermediador.bankAccounts.update({
        bankAccountId: id,
        bankAccount: {
          status: 'INACTIVE',
        },
      })
      snackbar.open({
        message: `${`Atualizado com sucesso!`}`,
        variant: 'success',
      })
      refresh()
    } catch (error) {
      snackbar.open({
        message: error?.response?.data?.error?.message || `Ocorreu um erro`,
        variant: 'error',
      })
    }
  }

  const enableBank = async (id) => {
    //ativar banco
    try {
      await service.intermediador.bankAccounts.update({
        bankAccountId: id,
        bankAccount: {
          status: 'ACTIVE',
        },
      })
      snackbar.open({
        message: `${`Atualizado com sucesso!`}`,
        variant: 'success',
      })
      refresh()
    } catch (error) {
      snackbar.open({
        message: error?.response?.data?.error?.message || `Ocorreu um erro`,
        variant: 'error',
      })
    }
  }

  const primaryBank = async (id) => {
    //conta primária
    try {
      await service.intermediador.bankAccounts.update({
        bankAccountId: id,
        bankAccount: {
          status: 'PRIMARY',
        },
      })
      snackbar.open({
        message: `${`Atualizado com sucesso!`}`,
        variant: 'success',
      })
      refresh()
    } catch (error) {
      snackbar.open({
        message: error?.response?.data?.error?.message || `Ocorreu um erro`,
        variant: 'error',
      })
    }
  }

  return (
    <ButtonBase
      disabled={false}
      style={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: setBackgroundColor(value),
        padding: '20px',
        borderRadius: '20px',
        width: '100%',
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{'Detalhes'}</DialogTitle>
        <ModalStatus value={value} />
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Voltar
          </Button>
        </DialogActions>
      </Dialog>
      <>
        <Label value={value} />
        {/* <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#e8ecec',
            borderRadius: '120px',
            width: '40px',
            height: '40px',
          }}
        >
          <HomeIcon size={16} />
        </Box> */}
        <Typography variant="body2" color="textSecondary">
          {value?.bank}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Agência: {value?.agency}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Número: {value?.number}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Chave PIX: {value?.number}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {value?.documentType}: {value?.document}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Criado em {helpers.formatters.dateTime(value?.createdAt)}
        </Typography>
        {value?.status !== 'WAITING_CONFIRMATION' && (
          <Button
            variant="contained"
            color="primary"
            style={{
              marginTop: '20px',
              width: '100%',
              opacity: showOptions ? 1 : 0,
              visibility: showOptions ? 'visible' : 'hidden',
              transition: 'opacity 0.3s ease, visibility 0.3s ease',
            }}
            onClick={handleOpen}
          >
            OPÇÕES
          </Button>
        )}
      </>
    </ButtonBase>
  )
}

export default CardComponent
